import axios from 'axios';
import authHeader from './auth-header';
import { cookieNameGenerator } from '../helpers/helpers';

const API_URL = process.env.REACT_APP_API;
const appName = process.env.REACT_APP_NAME;
const publicKey = process.env.REACT_APP_PUBLIC_KEY;

const login = async (username, password) => {
	return axios
		.post(
			`${API_URL}auth/signin`,
			{ username, password, request_from: 'web' },
			{ headers: await authHeader() },
		)
		.then(async (response) => {
			return response;
		});
};

const generateToken = async () => {
	const payload = {
		'x-public-key': publicKey,
		'x-app-name': appName,
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	};
	return axios
		.post(
			`${API_URL}auth/app-token`,
			{},
			{
				headers: payload,
			},
		)
		.then(async (response) => {
			if (response.data.appToken) {
				localStorage.setItem('appToken', JSON.stringify(response.data));
			}

			return response;
		});
};
const logout = (removeCookie) => {
	removeCookie(cookieNameGenerator('ssocookies'));
	removeCookie(cookieNameGenerator('ssoaccount'));
	removeCookie(cookieNameGenerator('ssophonenumber'));
	localStorage.clear();
	return window.location.reload();
};

const goONELNKHomapage = () => {
	return localStorage.clear();
};

const loginPhone = async (payload) => {
	return axios
		.post(`${API_URL}auth/phone`, payload, { headers: await authHeader() })
		.then(async (response) => {
			return response;
		});
};
const register = async (username, email, password) => {
	return axios.post(
		`${API_URL}auth/signup`,
		{
			username,
			email,
			password,
		},
		{ headers: await authHeader() },
	);
};

const getMenu = async (role) => {
	console.log('role in getMenu:', role);
	return axios
		.get(`${API_URL}authorization/`, { headers: await authHeader(), params: role })
		.then((response) => {
			localStorage.setItem('menu', JSON.stringify(response.data));
			return response.data;
		});
};

const getMenuByUsername = async (role) => {
	return axios
		.get(`${API_URL}authorization/role-by-username/`, {
			headers: await authHeader(),
			params: role,
		})
		.then((response) => {
			localStorage.setItem('menu', JSON.stringify(response.data));
			return response.data;
		});
};
const loginSSO = async (payload) => {
	return axios
		.post(`${API_URL}auth/signin-sso`, payload, { headers: await authHeader() })
		.then(async (response) => {
			return response;
		});
};

export default {
	login,
	logout,
	register,
	getMenu,
	generateToken,
	getMenuByUsername,
	loginSSO,
	goONELNKHomapage,
	loginPhone,
};
